import { FC } from "react";

import { Icon } from "atoms/icon/Icon";
import CloseSVG from "atoms/icon/icons/close.svg";

export interface AdvisorMissingOutCardProps {
  onButtonClick: () => void;
  onClose?: () => void;
  title?: string;
  description?: string;
  subtitle?: string;
  buttonText?: string;
  buttonColor?: string;
}

export const AdvisorMissingOutCard: FC<AdvisorMissingOutCardProps> = ({
  onButtonClick,
  onClose,
  title = "You're missing out!",
  description = "Unlock personalized recommendations by answering a few questions.",
  subtitle = "(takes less than 1 min)",
  buttonText = "Get Started",
  buttonColor,
}) => {
  const paddingY = onClose ? "py-10" : "py-6";
  return (
    <div
      className={`relative flex flex-col items-center rounded-lg bg-white px-4 ${paddingY}`}
    >
      {onClose && (
        <button
          onClick={onClose}
          className="absolute right-2 top-2 flex h-6 w-6 items-center justify-center rounded-full transition-colors hover:bg-black/5 active:bg-black/10"
          aria-label="Close"
        >
          <Icon svg={CloseSVG} size="small" color="primaryText" />
        </button>
      )}

      <h2 className="mb-4 text-center font-serif text-[30px] italic leading-[33px] text-[#091f24]">
        {title}
      </h2>

      <p className="mb-1.5 text-center text-base leading-[18px] text-black opacity-80">
        {description}
      </p>

      <p className="mb-6 text-center font-sans text-base italic leading-[18px] text-[#6b7070]">
        {subtitle}
      </p>

      <button
        onClick={onButtonClick}
        className="flex items-center justify-center rounded-full bg-brand-color px-16 py-2 font-sans text-base font-medium leading-[22px] text-white shadow-[0px_2px_10px_0px_rgba(0,0,0,0.06)] transition-opacity hover:opacity-90 active:opacity-80"
        style={{ backgroundColor: buttonColor }}
      >
        {buttonText}
      </button>
    </div>
  );
};
